/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEMENTORREQUIREMENT= createAsyncThunk(
  "updateMentorRequirement/updateMentorRequirement",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateMentorRequirementSlice = createSlice({
  name: "updateMentorRequirementSlice",
  initialState: {
    updateMentorRequirement: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateMentorRequirement: (state) => {
        state.updateMentorRequirement.loading = false
        state.updateMentorRequirement.error = false
        state.updateMentorRequirement.data = []
        state.updateMentorRequirement.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEMENTORREQUIREMENT.fulfilled, (state, action) => {
      state.updateMentorRequirement = {
        ...state.updateMentorRequirement,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEMENTORREQUIREMENT.pending, (state, action) => {
      state.updateMentorRequirement = {
        ...state.updateMentorRequirement,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEMENTORREQUIREMENT.rejected, (state, action) => {
      state.updateMentorRequirement = {
        ...state.updateMentorRequirement,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateMentorRequirementAction = {
    UPDATEMENTORREQUIREMENT,
};

export { updateMentorRequirementAction };
export default updateMentorRequirementSlice.reducer;
export const {setInitialStateOfupdateMentorRequirement} = updateMentorRequirementSlice.actions